import React from "react";
import { useNavigate } from "react-router-dom";
import { swatchForColor } from "@/lib/colorSwatches";

const ColorVariants = ({ variants = [], currentId, currentColor }) => {
  const navigate = useNavigate();

  if (!variants || variants.length <= 1) return null;

  return (
    <div data-testid="color-variants">
      <p className="overline mb-3">Colour</p>
      <p className="serif text-base mb-3">{currentColor}</p>
      <div className="flex flex-wrap gap-2.5">
        {variants.map((variant) => {
          const active = variant.id === currentId;
          const hex = swatchForColor(variant.color);
          return (
            <button
              key={variant.id}
              type="button"
              title={variant.color}
              aria-label={`${variant.color}${active ? " (selected)" : ""}${!variant.in_stock ? " — out of stock" : ""}`}
              aria-pressed={active}
              disabled={active}
              onClick={() => {
                if (!active) navigate(`/product/${variant.id}`);
              }}
              data-testid={`color-variant-${variant.id}`}
              className={`relative w-10 h-10 rounded-full border-2 transition shrink-0 ${
                active ? "border-primary ring-2 ring-primary/20" : "border-border hover:border-primary"
              } ${!variant.in_stock ? "opacity-45" : ""}`}
              style={{ backgroundColor: hex }}
            >
              {!variant.in_stock && (
                <span className="absolute inset-0 flex items-center justify-center pointer-events-none">
                  <span className="block w-full h-px bg-primary rotate-45" />
                </span>
              )}
            </button>
          );
        })}
      </div>
      <p className="text-xs text-secondary mt-2">
        {variants.length} colour{variants.length === 1 ? "" : "s"} available in this design
      </p>
    </div>
  );
};

export default ColorVariants;
